import { Component, OnInit } from '@angular/core';
import { JobService } from '@services/job/job.service';
import { BaseComponent } from '@library-shared/base/base.component';
import { environment } from '@env/environment';
import { DxButtonModule } from 'devextreme-angular';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    styleUrls: ['./admin-dashboard.component.scss'],
    imports: [DxButtonModule, RouterModule]
})
export class AdminDashboardComponent extends BaseComponent implements OnInit {
    constructor(private jobService: JobService) {
        super();
    }

    ngOnInit(): void {}

    ExportToSureBank() {
        this.jobService.TrafficPayToSureBank_Job().subscribe({
            next: (data) => {
                this.toast_info({ message: 'Export job queued' });
            },
        });
    }

    ImportFromSureBank() {
        this.jobService.SureBankToTrafficPay_Job().subscribe({
            next: (data) => {
                this.toast_info({ message: 'Import job queued' });
            },
        });
    }

    get jobViewerURL(): string {
        return `${environment.apiURL}/hf99`;
    }

    FinalizePayments() {
        this.jobService.TrafficPayVoidRefund_Job().subscribe({
            next: (data) => {
                this.toast_info({ message: 'Void/Refund job queued' });
            },
        });
    }

    JobQueue_Job() {
        this.jobService.JobQueue_Job().subscribe({
            next: (data) => {
                this.toast_info({ message: 'Queue job queued' });
            },
        });
    }

    TrafficaPayNewPayments_Job() {
        this.jobService.TrafficaPayNewPayments_Job().subscribe({
            next: (data) => {
                this.toast_info({ message: 'New Payments job queued' });
            },
        });
    }
}
